<template>
  <div>
    <van-field v-if="name == 'edit'" v-model="ruleForm[items.name]" @click="opentime(items.name)" :label="items.title" label-width="120" label-align="right"
               placeholder="请选择日期时间" :rules="items.required?[{ required: true, message: '必填' }]:[{}]" :readonly="items.editdis"></van-field>
    <van-field v-else v-model="ruleForm[items.name]" @click="opentime(items.name)"
               placeholder="请选择日期时间" :rules="items.required?[{ required: true, message: '必填' }]:[{}]" :readonly="items.editdis"></van-field>
    <!--   日期、时间弹出框-->
    <van-popup v-model="show" position="bottom" :style="{ height: '50%' }" >
      <van-datetime-picker v-model="currentDateTime" type="datetime"  title="选择日期时间"  @confirm="getDateTime" @cancel="show = false"/>
    </van-popup>
  </div>
</template>

<script>
import mixins from "@/mixins/index"
export default {
  name: "datetimeElement",
  mixins: [mixins],
  props: ['items','ruleForm',"name"],
  data(){
    return{
      show: false,
      currentDateTime: "",
    }
  },
  methods: {
    getDateTime(datetime){
      this.ruleForm[this.timeitem] = this.formatDateTime(datetime);
      this.show = false;
    },
    cancel(){
      this.show=false;
    },
    opentime(item){
      this.timeitem=item;
      this.currentDateTime = new Date();
      this.show = true;
    },
  }
}
</script>

<style scoped>

</style>